// extracted by mini-css-extract-plugin
export default {"select__input":"Select_select__input__6V5DK","select__input__menu":"Select_select__input__menu__xQSvu"};